import { register } from '@/api/home'
import { loginHandleToken } from '@/utils/auth'
const user = {
  namespaced: true,

  state: {},

  actions: {
    // 登录
    Register({ commit }, registerInfo) {
      return new Promise((resolve, reject) => {
        register(registerInfo)
          .then(res => {
            // loginHandleToken(res.result)
            const { status } = res
            !!(status === 0) && loginHandleToken(res.result[0])
            resolve(res)
          })
          .catch(error => {
            // res?.data
            resolve(error?.data)
          })
      })
    }
  }
}

export default user
